"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _slicedToArray = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _formik = require("formik");
var yup = _interopRequireWildcard(require("yup"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SMS_TIMEOUT_MINUTES = process.env.REACT_APP_SMS_TIMEOUT_MINUTES;
var RESEND_COUNTER_SEC = 30;
var MIN = 0;
var MAX = RESEND_COUNTER_SEC;
var OtpVerifySmsCode = function OtpVerifySmsCode(_ref) {
  var handleBack = _ref.handleBack,
    handleVerify = _ref.handleVerify,
    handleResend = _ref.handleResend,
    data = _ref.data,
    commonErrorMessage = _ref.commonErrorMessage,
    classes = _ref.classes,
    isLoading = _ref.isLoading;
  var abortController = new AbortController();
  var _react$default$useSta = _react.default.useState("".concat(SMS_TIMEOUT_MINUTES, ":00")),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    timer = _react$default$useSta2[0],
    setTimer = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    timerExpired = _react$default$useSta4[0],
    setTimerExpired = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState(false),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    timerInterval = _react$default$useSta6[0],
    setTimerInterval = _react$default$useSta6[1];
  var _react$default$useSta7 = _react.default.useState({
      code: ''
    }),
    _react$default$useSta8 = _slicedToArray(_react$default$useSta7, 2),
    initialValues = _react$default$useSta8[0],
    setInitialValues = _react$default$useSta8[1];
  var _react$default$useSta9 = _react.default.useState(true),
    _react$default$useSta10 = _slicedToArray(_react$default$useSta9, 2),
    disableResend = _react$default$useSta10[0],
    setDisableResend = _react$default$useSta10[1];
  var _react$default$useSta11 = _react.default.useState(RESEND_COUNTER_SEC),
    _react$default$useSta12 = _slicedToArray(_react$default$useSta11, 2),
    resendCounter = _react$default$useSta12[0],
    setResendCounter = _react$default$useSta12[1];
  var normalise = function normalise(value) {
    return (value - MIN) * 100 / (MAX - MIN);
  };
  var onBackClicked = function onBackClicked() {
    clearInterval(timerInterval);
    handleBack();
  };
  var onResendClicked = function onResendClicked() {
    setDisableResend(true);
    setResendCounter(RESEND_COUNTER_SEC);
    clearInterval(timerInterval);
    initTimer();
    handleResend();
  };
  var initTimer = function initTimer() {
    var time = new Date().getTime() + SMS_TIMEOUT_MINUTES * 60 * 1000;
    var interval = setInterval(function () {
      var now = new Date().getTime();
      var left = time - now;
      var minutes = Math.floor(left % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(left % (1000 * 60) / 1000);
      setTimer("".concat(minutes, ":").concat(seconds < 10 ? "0".concat(seconds) : seconds));
      if (left < 1000) {
        setTimerExpired(true);
        clearInterval(interval);
      }
    }, 1000);
    setTimerInterval(interval);
  };
  var initDisableResendTimer = function initDisableResendTimer() {
    if (resendCounter > 0) {
      setTimeout(function () {
        return setResendCounter(resendCounter - 1);
      }, 1000);
    } else {
      setDisableResend(false);
    }
  };
  var setOTPFromSMS = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var otp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!('OTPCredential' in window)) {
                _context.next = 13;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return navigator.credentials.get({
                otp: {
                  transport: ['sms']
                },
                signal: abortController.signal
              });
            case 4:
              otp = _context.sent;
              setInitialValues({
                code: otp.code
              });
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);
            case 11:
              _context.next = 14;
              break;
            case 13:
              abortController.abort();
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function setOTPFromSMS() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSubmit = function handleSubmit() {
    abortController.abort();
    handleVerify.apply(void 0, arguments);
  };
  _react.default.useEffect(function () {
    initTimer();
    setOTPFromSMS();
    return function () {
      abortController.abort();
      clearInterval(timerInterval);
    };
  }, []);
  _react.default.useEffect(function () {
    initDisableResendTimer();
  }, [resendCounter]);
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    justify: 'space-between',
    direction: 'row'
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.messageTop
  }, "\u05E1\u05D9\u05E1\u05DE\u05D0 \u05E0\u05E9\u05DC\u05D7\u05D4 \u05DC\u05DE\u05E1\u05E4\u05E8 \u05E9\u05D4\u05D6\u05E0\u05EA"), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement("strong", {
    className: classes.messageTop
  }, data.phoneNumber)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    height: 21
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "text",
    className: classes.linkAlt,
    onClick: onBackClicked
  }, "\u05E9\u05DC\u05D9\u05D7\u05D4 \u05DC\u05D8\u05DC\u05E4\u05D5\u05DF \u05D0\u05D7\u05E8"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: {
      md: 4,
      xs: 2
    },
    mr: 6,
    borderRight: 1,
    className: classes.withBorder
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: {
      md: 'block',
      xs: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.messageDefault
  }, "\u05EA\u05D5\u05E7\u05E3 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D0:")), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.textVeryLarge
  }, timer)), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement("strong", {
    className: classes.messageMutted
  }, "\u05D3\u05E7\u05D5\u05EA")))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 7
  }, commonErrorMessage ? /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.messageError
  }, commonErrorMessage)) : '', /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 5,
    ml: {
      md: 4
    },
    mb: {
      sm: 10,
      xs: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    onSubmit: handleSubmit,
    validationSchema: yup.object().shape({
      code: yup.string().required('שדה חובה').matches(/\d{6}/, 'הסיסמה צריכה להיות בעלת 6 ספרות').length(6, 'הסיסמה צריכה להיות בעלת 6 ספרות')
    }),
    initialValues: initialValues,
    enableReinitialize: true
  }, function (_ref3) {
    var values = _ref3.values,
      errors = _ref3.errors,
      touched = _ref3.touched,
      handleChange = _ref3.handleChange,
      handleBlur = _ref3.handleBlur;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 11
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'otp-code',
      onBlur: handleBlur,
      value: values.code,
      className: classes.formControl,
      label: 'הזינו סיסמא',
      onChange: handleChange,
      name: "code",
      error: errors.code && touched.code,
      helperText: errors.code && touched.code ? /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'code'
      }) : '',
      type: "text",
      autoComplete: "one-time-code",
      inputProps: {
        inputMode: 'numeric'
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      disabled: timerExpired || isLoading,
      type: "submit",
      size: "large",
      className: classes.submitButton
    }, isLoading ? /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null) : 'קבלת הצעות')), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      sm: 6,
      direction: "column",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.textButton,
      disabled: disableResend,
      variant: "text",
      size: "large",
      onClick: onResendClicked
    }, "\u05E9\u05DC\u05D9\u05D7\u05EA \u05D4\u05E1\u05D9\u05E1\u05DE\u05D0 \u05E9\u05D5\u05D1")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, disableResend && /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
      variant: "determinate",
      value: normalise(resendCounter)
    })))));
  }))));
};
OtpVerifySmsCode.propTypes = {
  classes: _propTypes.default.object,
  commonErrorMessage: _propTypes.default.string,
  data: _propTypes.default.object,
  handleBack: _propTypes.default.func,
  handleResend: _propTypes.default.func,
  handleVerify: _propTypes.default.func,
  isLoading: _propTypes.default.bool
};
var _default = exports.default = OtpVerifySmsCode;